import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { BASE_URL } from '../config';

const AuthCallback = () => {
  const [error, setError] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      // Get the code from URL query parameters
      const urlParams = new URLSearchParams(location.search);
      const code = urlParams.get('code');
      
      if (!code) {
        setError('Authentication failed: No authorization code received.');
        return;
      }

      // Prevent multiple requests
      if (isProcessing) {
        return;
      }
      
      setIsProcessing(true);
      
      try {
        // Exchange the code for an access token and user data
        const response = await fetch(`${BASE_URL}/auth/google/callback?code=${code}`, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
          },
        });
        
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.detail || 'Authentication failed');
        }
        
        const authData = await response.json();
        
        // Login the user and redirect
        await login(authData);
        navigate('/dashboard');
      } catch (error) {
        console.error('Authentication callback error:', error);
        setError(`Authentication failed: ${error.message}`);
        setIsProcessing(false);
      }
    };
    
    handleCallback();
  }, [location.search, login, navigate, isProcessing]); // Only re-run if these dependencies change

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {error ? (
          <div className="p-3 bg-red-100 text-red-700 rounded">
            {error}
          </div>
        ) : (
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
            <p className="mt-4 text-gray-600">Processing authentication...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthCallback; 